import React, { Component } from 'react';
import PropTypes from 'prop-types';

import functions from "../../api/functions.js";
import { api } from "../../api/api.js";

export const LoginContext = React.createContext();

const AgregarClaseABody = (classname)=>{
	document.body.classList.add(classname);
}
const QuitarClaseABody = (classname)=>{
	document.body.classList.remove(classname);
}

class LoginProvider extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: null,
			loading: false,
			logged: false,
			errorMsg:"",
		}
	}

	static propTypes = {
		children: PropTypes.any,
	}

	componentDidUpdate() {
		if(this.state.logged == true && (localStorage.getItem('token') == undefined )) {
		    window.location.reload();
		}
	}

	componentDidMount() {
		this.load((result) => {
			if (result) {
				this.isLogged();
			}
		});
	}

	decode() {
		let token = localStorage.getItem('token');
		if (token) {
			return atob(token);
		} else {
			return false;
		}
	}

	load(callback) {
		let decoded = this.decode();
		if ((decoded) && (this.ValidToken(decoded))) {
			this.setState({ token: JSON.parse(decoded), logged:true, errorMsg:"" }, () => {
				if (callback) callback(true);
			});
		} else {
			localStorage.removeItem('token');
			this.setState({ token: "", logged: false, errorMsg : "" });
		}

		if (callback) callback(false);
	}

	encode() {
		const { token } = this.state;
		return btoa(JSON.stringify(token));
	}

	save() {
		localStorage.setItem('token', this.encode());
	}

	isLogged(callback) {
		const { token } = this.state;
		functions.post(api.auth.check, null, { token: token }, (data) => {
			if (data.meta.allowed == true && data.data !== undefined && data.data.exists == true) {
				localStorage.setItem('config_ShowPrecioLista', data.data.config && data.data.config.ShowPrecioLista == true);
				localStorage.setItem('config_ShowPrecioCostoConIVA', data.data.config && data.data.config.ShowPrecioCostoConIVA == true);
				localStorage.setItem('config_ShowPrecioCostoSinIVA', data.data.config && data.data.config.ShowPrecioCostoSinIVA == true);
				QuitarClaseABody("showScrollY");
				AgregarClaseABody("showScrollY");
				this.setState({ logged: true });
				if (callback) callback(true);
			} else {
				this.setState({ logged: false});
				QuitarClaseABody("showScrollY");
				localStorage.removeItem('token');
				if (callback) callback(false);
			}
		}, () => {
			this.setState({ logged: false });
			QuitarClaseABody("showScrollY");
			localStorage.removeItem('token');
			if (callback) callback(false);
		})
	}

	ValidToken(token){
	     return(
	          token !== undefined &&
	          token !== null &&
	          token != btoa("") &&
	          token != btoa(undefined) &&
			token != btoa(null) &&
			token.length>=40
	     );
	}

	setToken(token, errorMsg="", callback) {
		this.setState({ token: token, logged: token != null ? true : false, errorMsg:errorMsg }, () => {
			this.save();
		}, () => {
			if (callback) callback();
		});
	}

	ValidCartItems(cartItems){
	     return(
	          cartItems !== undefined &&
	          cartItems !== null &&
	          cartItems != btoa("") &&
	          cartItems != btoa(undefined) &&
			cartItems != btoa(null)
	     );
	}

	setCartItems(cartItems) {
		if(this.ValidCartItems(cartItems)) localStorage.setItem('cartItems', cartItems);
	}

	login(username, password, callback) {
		functions.post(api.auth.login, null,
			{
				username: username,
				password: password
			},
			(data) => {
				if (data.meta.allowed && this.ValidToken(data.data.token)) {
					this.setCartItems(data.data.cartItems);
					localStorage.setItem('displayname', username);
					this.setToken(data.data.token);
					callback(true);
				} else {
					if(data.errors !== undefined && data.errors.error !== undefined){
						this.setToken(null, data.errors.error);
					}
					else if(data.detail != undefined){
						this.setToken(null, data.detail);
					}
					else{
						this.setToken(null);
					}
					localStorage.setItem('displayname', '');
					localStorage.setItem('cartItems', '');
					callback(false);
				}
			}, (data) => {
				if(data.errors !== undefined && data.errors.error !== undefined){
					this.setToken(null, data.errors.error);
				}
				else if(data.detail != undefined){
					this.setToken(null, data.detail);
				}
				else{
					this.setToken(null);
				}
				localStorage.setItem('displayname', '');
				localStorage.setItem('cartItems', '');
				callback(false);
			}
		);
	}

	logout() {
		let cartItems = localStorage.getItem('cartItems');
		functions.post(api.auth.logoff, null,
			{
				cartItems: cartItems != undefined && cartItems != null ? cartItems : '',
			},
			(data) => {
				QuitarClaseABody("showScrollY");
				localStorage.removeItem('token');
				localStorage.removeItem('displayname');
				localStorage.removeItem('cartItems');

				//limpiar claves del pop-up al cerrar sesión
				try {
					Object.keys(sessionStorage)
					.filter(k => k.startsWith("popupCatalogoShown"))
					.forEach(k => sessionStorage.removeItem(k));
				} catch (e) {
					console.warn("No se pudo limpiar popupCatalogoShown", e);
				}

				this.setState({ token: "", logged: false, errorMsg : "" });
			}, (data) => {
				QuitarClaseABody("showScrollY");
				localStorage.removeItem('token');
				localStorage.removeItem('displayname');
				localStorage.removeItem('cartItems');

				//también en caso de error al cerrar sesión
				try {
					Object.keys(sessionStorage)
					.filter(k => k.startsWith("popupCatalogoShown"))
					.forEach(k => sessionStorage.removeItem(k));
				} catch (e) {
					console.warn("No se pudo limpiar popupCatalogoShown", e);
				}
				this.setState({ token: "", logged: false, errorMsg : "" });
			}
		);
	}

	render() {
		const { token, loading, logged, errorMsg } = this.state;
		const { children } = this.props;
		return (
			<LoginContext.Provider value={{
				token: token,
				login: (username, password, callback) => this.login(username, password, callback),
				setToken: (token) => this.setToken(token),
				isLogged: (callback) => this.isLogged(callback),
				logout: () => this.logout(),
				logged: logged,
				loading: loading,
				errorMsg: errorMsg
			}}>
				{children}
			</LoginContext.Provider >
		)
	}
}

export default LoginProvider;



// WEBPACK FOOTER //
// ./src/components/ParadigmaLoginProvider/ParadigmaLoginProvider.js